import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import CustomSelect from "./CustomSelect";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";
import scanImg from "../../../../picture/scan.png";
import notifImg from "../../../../picture/notification.png";
import minusImg from "../../../../picture/minus.png";
import DateSelect from "./DateSelect";
import FullScreenLoader from "../../FullScreenLoader/FullScreenLoader";

const dokumentEmpty = {
  nazivSredstva: { id: -1, name: "" },
  vrstaSredstva: { id: -1, name: "" },
  vrstaDokumenta: { id: -1, name: "" },
  brojDokumenta: "",
  vaziOd: "",
  vaziDo: "",
  brojDana: "30",
  scan: false,
  customNaziv: "" // Novo polje za OD
};

const isEmptyDate = (date) =>
  !date || date.split(".").find((d) => !d) !== undefined;

function SredstvaNeLZOForm({ fileNewDocument, vrstaSredstva }) {
  const {
    dictionary,
    setIsGlobalnoDodavanjeDokumenta,
    baseUrl,
    apiKey,
    loggedUser
  } = useGlobalContext();

  const [dokument, setDokument] = useState(dokumentEmpty);
  const [naziviSredstvaAll, setNaziviSredstvaAll] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const vrsteDokumentaAll = [
    { id: "TD", name: "Tehnička dokumentacija" },
    { id: "SN", name: "Stručni nalaz" },
    { id: "RG", name: "Registracija" },
    { id: "PU", name: "Periodični pregled" },
    { id: "OD", name: "Ostalo" }
  ];

  useEffect(() => {
    const fetchMachines = async () => {
      if (!loggedUser) return;
      try {
        const { data } = await axios.post(
          `${baseUrl}/machines/read_machines.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            company_id: 1, // Ovde mozes staviti loggedUser.company_id
            status_filter: "AKTIVNA"
          }
        );
        if (data.status === 200) {
          setNaziviSredstvaAll(
            data.data.map((m) => ({
              id: m.masina_id,
              name: `${m.tip} - ${m.oznaka}`
            }))
          );
        }
      } catch (e) {
        console.error("Greška pri učitavanju mašina", e);
      }
    };
    fetchMachines();
  }, [baseUrl, loggedUser, apiKey]);

  useEffect(() => {
    setDokument((prev) => ({ ...prev, vrstaSredstva }));
  }, [vrstaSredstva]);

  const onChange = (newValue, field) => {
    if (field === "brojDana") {
      const dvocifrenRegex = /^([1-9]\d?)?$/;
      if (newValue && !dvocifrenRegex.test(newValue)) return;
    }
    setDokument((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleSave = async () => {
    if (
      dokument.nazivSredstva.id === -1 ||
      dokument.vrstaDokumenta.id === -1 ||
      !fileNewDocument
    ) {
      alert("Popunite mašinu, vrstu dokumenta i izaberite fajl.");
      return;
    }

    const nazivZaBazu =
      dokument.vrstaDokumenta.id === "OD"
        ? dokument.customNaziv
        : dokument.vrstaDokumenta.name;

    console.log("=== NAZIV KOJI SE ŠALJE ===");
    console.log("vrstaDokumenta.id:", dokument.vrstaDokumenta.id);
    console.log("vrstaDokumenta.name:", dokument.vrstaDokumenta.name);
    console.log("nazivZaBazu:", nazivZaBazu);

    const formData = new FormData();
    formData.append("file", fileNewDocument);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);
    formData.append("masina_id", dokument.nazivSredstva.id);
    formData.append("tip_dokumenta", dokument.vrstaDokumenta.id);
    formData.append("broj_dokumenta", dokument.brojDokumenta);
    formData.append("datum_izdavanja", dokument.vaziOd);
    formData.append("datum_isteka", dokument.vaziDo);
    formData.append("notifikacija_dana", dokument.brojDana);
    formData.append("is_scan", dokument.scan ? "1" : "0");
    formData.append("naziv", nazivZaBazu);

    console.log("=== SENDING DATA ===");
    console.log("URL:", `${baseUrl}/machines/upsert_initial_document.php`);
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    console.log("=== FormData being sent ===");
    console.log("masina_id:", dokument.nazivSredstva.id);
    console.log("tip_dokumenta:", dokument.vrstaDokumenta.id);
    console.log("naziv:", nazivZaBazu);
    console.log("datum_izdavanja:", dokument.vaziOd);
    console.log("datum_isteka:", dokument.vaziDo);
    console.log("notifikacija_dana:", dokument.brojDana);
    console.log("file:", fileNewDocument);

    try {
      setIsLoading(true);
      const { data } = await axios.post(
        `${baseUrl}/machines/upsert_initial_document.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 30000
        }
      );

      setIsLoading(false);
      console.log("=== RESPONSE ===", data);

      if (data.status === 200) {
        window.dispatchEvent(new Event("machineAdded"));
        setIsGlobalnoDodavanjeDokumenta(false);
        alert("Uspešno sačuvano!");
      } else {
        alert(data.message || "Greška pri čuvanju");
      }
    } catch (error) {
      console.error("=== ERROR ===", error);
      if (error.response) {
        console.log("Response data:", error.response.data);
        console.log("Response status:", error.response.status);
        alert(
          `Greška: ${error.response.data.message || error.response.status}`
        );
      } else if (error.request) {
        console.log("No response received:", error.request);
        alert("Nema odgovora od servera - proveri debug_upload.log");
      } else {
        alert("Greška: " + error.message);
      }
    }
  };

  const handleOdustani = () => setIsGlobalnoDodavanjeDokumenta(false);

  const isDisabledSave =
    !dokument.nazivSredstva.name ||
    !dokument.vrstaSredstva.name ||
    !dokument.vrstaDokumenta.name ||
    !dokument.brojDokumenta ||
    isEmptyDate(dokument.vaziOd) ||
    isEmptyDate(dokument.vaziDo) ||
    !dokument.brojDana;

  if (isLoading) return <FullScreenLoader />;

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "flex-end"
        }}
      >
        <CustomSelect
          label={dictionary["nazivSredstva"]}
          allValues={naziviSredstvaAll}
          selectedValue={dokument.nazivSredstva}
          onSelectChange={(value) => onChange(value, "nazivSredstva")}
        />
        <CustomSelect
          label={dictionary["vrstaDokumenta"]}
          allValues={vrsteDokumentaAll}
          selectedValue={dokument.vrstaDokumenta}
          onSelectChange={(value) => onChange(value, "vrstaDokumenta")}
        />
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["brojDokumenta"]}
          </div>
          <input
            value={dokument.brojDokumenta}
            onChange={(e) => onChange(e.target.value, "brojDokumenta")}
            style={{ height: "40px", padding: "10px", fontSize: "16px" }}
          />
        </div>

        {/* POLJE ZA NAZIV AKO JE OSTALA DOKUMENTACIJA */}
        {dokument.vrstaDokumenta?.id === "OD" && (
          <div style={{ marginLeft: "10px" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "5px",
                color: "orange"
              }}
            >
              Naziv ostale dokumentacije
            </div>
            <input
              type="text"
              value={dokument.customNaziv}
              onChange={(e) => onChange(e.target.value, "customNaziv")}
              placeholder="Npr. Atest kuke, Polisa..."
              style={{
                height: "40px",
                padding: "10px",
                fontSize: "16px",
                border: "1px solid orange",
                width: "250px"
              }}
            />
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        <div>
          <DateSelect
            label={dictionary["vaziOd"]}
            selectedValue={dokument.vaziOd}
            onSelectChange={(value) => onChange(value, "vaziOd")}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", height: "40px" }}>
          <img src={minusImg} style={{ width: "30px" }} alt="minus" />
        </div>
        <div>
          <DateSelect
            label={dictionary["vaziDo"]}
            selectedValue={dokument.vaziDo}
            onSelectChange={(value) => onChange(value, "vaziDo")}
          />
        </div>
        <div>
          <div>
            <img src={notifImg} style={{ width: "40px" }} alt="notification" />
          </div>
          <input
            value={dokument.brojDana}
            onChange={(e) => onChange(e.target.value, "brojDana")}
            style={{
              height: "40px",
              padding: "10px",
              fontSize: "16px",
              width: "50px"
            }}
          />
          <span style={{ fontSize: "16px" }}>{`${dictionary["dan"]}/a`}</span>
        </div>
        <div>
          <div>
            <img src={scanImg} style={{ width: "30px" }} alt="scan" />
          </div>
          <input
            type="checkbox"
            checked={dokument.scan}
            onChange={(e) => onChange(e.target.checked, "scan")}
            style={{ height: "30px", width: "30px" }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        <div onClick={handleOdustani}>
          <Button activation={true} style={{ padding: "10px" }}>
            {dictionary["odustani"]}
          </Button>
        </div>
        <div onClick={handleSave} style={{ opacity: isDisabledSave ? 0.5 : 1 }}>
          <Button
            isDisabled={isDisabledSave}
            activation={true}
            style={{ padding: "10px" }}
          >
            {dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SredstvaNeLZOForm;
